import { PageHero } from "@/components/PageHero";

const ITEMS = [
  {
    title: "Move-in / Move-out",
    body: "Submit the form 48 hours before, between 8:00 AM — 7:00 PM. Lifts will be padded by the facility team. Sunday movements are not permitted.",
  },
  {
    title: "Interior Works",
    body: "All civil & carpentry work is allowed Mon — Sat, 10:00 AM — 6:00 PM. Drilling is restricted between 1:00 — 3:30 PM. Wet work is prohibited in lifts.",
  },
  {
    title: "Within-Society Transfers",
    body: "Moving between towers? Notify the management 24 hours in advance so we can coordinate lift bookings and security clearance.",
  },
  {
    title: "Material & Waste",
    body: "Use the service lift only. Debris must be collected by the contractor — do not pile in common areas, lobbies or staircases.",
  },
];

const Relocation = () => (
  <div data-testid="relocation-page">
    <PageHero
      overline="Relocation"
      title={
        <>
          Moving made
          <span className="italic text-brand-gold"> effortless.</span>
        </>
      }
      lead="Whether you're moving in, moving out or simply refreshing your interiors — here is the playbook."
      image="https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1600&q=80"
    />

    <section className="py-24 md:py-32 px-6 md:px-10">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6">
        {ITEMS.map((it, i) => (
          <div
            key={it.title}
            data-testid={`relocation-card-${i}`}
            className="p-10 rounded-2xl border border-brand-sage bg-brand-sage/30"
          >
            <div className="text-xs uppercase tracking-[0.2em] text-brand-leaf font-semibold mb-3">
              0{i + 1}
            </div>
            <h3 className="font-display text-3xl text-brand-forest">{it.title}</h3>
            <p className="text-brand-mute mt-4 leading-relaxed">{it.body}</p>
          </div>
        ))}
      </div>
    </section>
  </div>
);

export default Relocation;
